import { Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SAUTableModule, SAUTableSetting } from '@some-angular-utils/table';
import { SAUModalService } from '@some-angular-utils/modal';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { Urls } from '@/apiConnection/urls';
import { CompanyFormComponent } from '@/pages/companies/company-form/company-form.component';
import { CompanyDuplicateFormComponent } from '@/pages/companies/company-duplicate-form/company-duplicate-form.component';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { AuthenticationService } from '@/apiConnection/authentication.service';

// Inline <svg> (not <img src>) so sau-table's hover recolor reaches it - see DocumentReportCellsComponent.
const DUPLICATE_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path fill="none" d="M9 9h10.5a1.5 1.5 0 0 1 1.5 1.5V21a1.5 1.5 0 0 1-1.5 1.5H9A1.5 1.5 0 0 1 7.5 21V10.5A1.5 1.5 0 0 1 9 9Z"/><path fill="none" d="M4.5 15H4a1.5 1.5 0 0 1-1.5-1.5V3A1.5 1.5 0 0 1 4 1.5h10.5A1.5 1.5 0 0 1 16 3v.5"/></svg>`;

@Component({
  imports: [
    ReactiveFormsModule,
    RouterModule,
    SAUTableModule,
    AddButtonComponent,
  ],
  templateUrl: './company-list.page.html',
  styleUrl: './company-list.page.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CompanyListPage {

  @ViewChild('sauTable')
  sauTable: { getItems: () => void; refresh: () => void; } | undefined;

  private sauModalService = inject(SAUModalService);

  url = Urls.urls.companies;

  headers = [
    { name: 'ID',                  key: 'id' },
    { name: 'NOMBRE',              key: 'name' },
    { name: 'CIF/NIF',             key: 'cif' },
    { name: 'ESTADO',              key: 'is_active',   type: 'boolean' },
    { name: 'MÁX. USUARIOS',       key: 'max_users' },
    { name: 'FECHA CREACIÓN',      key: 'created_at',  type: 'dateTime' },
    { name: 'FECHA ACTUALIZACIÓN', key: 'updated_at',  type: 'dateTime' },
  ];

  readonly settings: SAUTableSetting[] = [
    {
      name: 'Duplicar compañía',
      color: '#7c3aed',
      icon: DUPLICATE_ICON,
      show: () => this.isSuperAdmin,
      click: (item: { id: number; name: string }) => this.openDuplicateForm(item),
    },
  ];

  get isSuperAdmin(): boolean {
    return this.authService.isSuperAdmin;
  }

  get selectedCompanyId(): number | null {
    return this.authService.selectedCompanyId;
  }

  constructor(private authService: AuthenticationService) {}

  openEditForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CompanyFormComponent, {});
    modalRef.componentInstance.id = item.id;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDuplicateForm(item: { id: number; name: string }) {
    const modalRef = this.sauModalService.open(CompanyDuplicateFormComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.sourceName = item.name;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDeleteForm(item: { id: number } = { id: 0 }) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = item.id;
    modalRef.componentInstance.url = this.url;
    modalRef.componentInstance.item = 'compañía';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.sauTable?.getItems();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  selectCompany(item: { id: number; name: string }) {
    this.authService.selectCompany(item);
  }

  clearSelection() {
    this.authService.clearCompanySelection();
  }
}
